import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private readonly key = 'sessionToken';
  private readonly id = 'userId';
   private readonly balance = 'walletBalance';

  private hasSessionSubject = new BehaviorSubject<boolean>(this.hasSession());

  hasSession$ = this.hasSessionSubject.asObservable();

  setSession(token: string): void {
    sessionStorage.setItem(this.key, token);
    this.hasSessionSubject.next(true);
  }
  setUserId(id: string): void {
    sessionStorage.setItem(this.id, id);
    this.hasSessionSubject.next(true);
  }
  setWalletBlance(balance: number): void {
    sessionStorage.setItem(this.balance, balance.toString());
    this.hasSessionSubject.next(true);
  }

  getSession(): string {
    return sessionStorage.getItem(this.key) ?? '';
  }
  getUserId(): string {
    return sessionStorage.getItem(this.id) ?? '';
  }
  getWalletBalance(): number {
    const value = sessionStorage.getItem(this.balance);
    return value ? Number(value) : 0;
  }
  hasSession(): boolean {
    return !!sessionStorage.getItem(this.key);
  }

  clear(): void {
    sessionStorage.removeItem(this.key);
    sessionStorage.removeItem(this.id);
    this.hasSessionSubject.next(false);
  }
}